import { InjectionToken } from '@angular/core';
import * as mapboxgl from 'mapbox-gl';
import { GeometricFormType } from 'src/app/geometrics-form/state/geometric-form.type';
import { LayerAction } from '../actions/layer-actions/layer-action';

export const PLOTTER =
  new InjectionToken<Plotter<any>>('Plotter');

export abstract class Plotter<T> {

  abstract type: GeometricFormType;
  abstract layer: mapboxgl.Layer;
  abstract mapper: any;

  constructor(private actions: LayerAction[]) {
  }

  init(mapbox: mapboxgl.Map) {
    this.initSource(mapbox);
    this.initLayer(mapbox);
  }

  protected initSource(mapbox: mapboxgl.Map) {

    mapbox.addSource(this.type, {
      type: 'geojson',
      data: {
        type: 'FeatureCollection',
        features: []
      }
    });
  }

  protected initLayer(mapbox: mapboxgl.Map) {

    mapbox.addLayer(this.layer);
    this.actions.forEach(a => {
      a.listen(mapbox, this.type);
    });
  }

  setElements(mapbox: mapboxgl.Map, elements: T[]) {
    this.setData(mapbox, elements);
  }

  clearData(mapbox: mapboxgl.Map) {
    if (this.getSource(mapbox)) {
      const oldValue = this.isVisible(mapbox);
      this.visible(mapbox, false);
      this.setData(mapbox, []);
      this.visible(mapbox, oldValue);
    }
  }

  isVisible(mapbox: mapboxgl.Map) {
    return mapbox.getLayoutProperty(this.type, 'visibility') === 'visible';
  }

  visible(mapbox: mapboxgl.Map, visible: boolean) {
    const visibility = visible ? 'visible' : 'none';
    mapbox.setLayoutProperty(this.type, 'visibility', visibility);
  }

  protected getSource(mapbox: mapboxgl.Map): mapboxgl.GeoJSONSource {
    return mapbox.getSource(this.type) as mapboxgl.GeoJSONSource;
  }

  protected getLayer(mapbox: mapboxgl.Map) {
    return mapbox.getLayer(this.type);
  }

  protected setData(mapbox: mapboxgl.Map, elements: T[]) {
    this.getSource(mapbox).setData({
      type: 'FeatureCollection',
      features: this.convert(elements)
    });
  }

  protected convert(elements: T[]): any {
    return elements.map(this.mapper);
  }

}
